module.exports = __webpack_public_path__ + "static/media/trapp.95e7362a.m4a";